import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { SemovelProvider } from '../../providers/semovel/semovel';
import { ViewProvider } from '../../providers/view/view';
import { LoginPage } from '../login/login';


@Component({
  selector: 'page-senha',
  templateUrl: 'senha.html',
})
export class SenhaPage {
  email:String = "";
  senha:String = "";

  confirmacaoSenha:String = "";

  codigo:String = "";

  showSenha = false;

  title = "Alterar Senha";

  constructor(public navCtrl: NavController, public navParams: NavParams, public server:SemovelProvider, private view:ViewProvider) {
    if(navParams.get('email')){
      this.email = navParams.get('email');
    }
    const title =navParams.get('title');
    if(title) this.title = title; 
  }

  solicitarAlteracao(){
    this.server.postData({method:"cliente/forgot-pass"}, {email:this.email}).subscribe(
      (sucesso) => {
        this.view.showMessage(sucesso.mensagem);
        this.showSenha = true;
      }
    )
  }

  confirmarAlteracao(){
    if(!this.codigo || !this.codigo.length ){
      this.view.showMessage("O código é obrigatória.");
      return;
    }

    if(!this.senha || !this.senha.length ){
      this.view.showMessage("A senha é obrigatória.");
      return;
    }

    if(this.senha !== this.confirmacaoSenha ){
      this.view.showMessage("A senha e a confirmação de senha são diferentes.");
      return;
    }

    this.server.postData({method:"cliente/change-forgot-pass"}, {email:this.email, codigo:this.codigo, senha:this.senha})
    .subscribe((sucesso) =>{
      if(sucesso.mensagem){
        this.view.showMessage(sucesso.mensagem);
      }
      this.abrirTelaLogin();
    });
  }
  
  abrirTelaLogin(){
    this.navCtrl.setRoot(LoginPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/senha/senha.ts